import {Fragment} from 'react'
import { useSelector } from 'react-redux'
import logoFrontapp from 'components/images/logos/logo_frontapp.svg'
import ChannelCard from "../../Utilities/ChannelCard";
import useFrontappSetup from "./useFrontappSetup";
import DataSourceWebhookModal from "../../Utilities/DataSourceWebhookModal";
import FrontappSetupInboxesModal from "./FrontappSetupInboxesModal";

export default function FrontappProvider() {
    const frontApp = useSelector((state) => state.frontAppOauth)
    const { initiateFrontappSetup, frontappSetupInboxesOpen, handleFrontappSetupInboxesClose } = useFrontappSetup({
        callbackPath: '/frontapp/accounts'
    })
    return (
        <Fragment>
            <ChannelCard
                icon={logoFrontapp}
                label={'Frontapp'}
                description={'Resolve support tickets and clear your backlog'}
                onClick={initiateFrontappSetup}
            />

            <FrontappSetupInboxesModal
                open={frontappSetupInboxesOpen && !frontApp?.showWebhookUrl}
                handleClose={handleFrontappSetupInboxesClose}
            />

            <DataSourceWebhookModal
                showWebhookUrl={frontApp?.showWebhookUrl}
                webhookUrl={frontApp?.webhookUrl}
                platformUrl={frontApp?.platformUrl}
                dataSourceName={'Frontapp'}
            />
        </Fragment>
    )
}